<template>
  <div
    id="main-banner"
    v-on-display="{ sectionInfo, context: this }"
    class="swiper-container multi-banner"
  >
    <h2 tabindex="0" class="ir">빅배너</h2>
    <template v-if="!isSingleCarousel">
      <div class="swiper-pagination-box">
        <div v-if="hasCellList" class="swiper-pagination-big-banner" />
      </div>
      <div class="swiper-button-box">
        <button type="button" class="swiper-button-prev">이전 배너</button>
        <button type="button" class="swiper-button-next">다음 배너</button>
      </div>
    </template>
    <template v-if="hasCellList">
      <div ref="multi-banner" class="swiper-wrapper">
        <div
          v-for="(cell, index) in cellList"
          :key="index"
          class="swiper-slide component-list"
        >
          <div class="picture-area">
            <WebpImage
              :image-info="{
                imageUrl: cell.image?.landscape_large?.background,
                width: 1860,
                height: 762,
                quality: 80,
                alt: getAltText(cell),
                className: 'big-banner',
              }"
            />
            <WebpImage
              :image-info="{
                imageUrl: cell.image?.landscape_large?.text,
                width: 1860,
                height: 762,
                quality: 80,
                alt: getAltText(cell),
                className: 'banner-title',
              }"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import fp from 'lodash/fp'
  import { getCellEventObject } from '@/common/utils/gnb.fp'
  import { ON_CLICK_CELL } from '@/common/resources/const'
  import { bannerLink } from '@/common/utils/common'
  import { onDisplay } from '@/common/resources/directives'
  import Swiper from '@/mixins/swiper'
  import CellMixin from '@/mixins/cell.mixin'
  import WebpImage from '@/components/image/WebpImage'

  import { convertBand } from '@/common/converter/convert-band'

  export default {
    name: 'BigBannerCatalog',
    components: { WebpImage },
    directives: {
      onDisplay,
    },
    mixins: [Swiper, CellMixin],
    props: {
      catalogInfo: {
        type: Object,
        default: () => {},
      },
      sectionInfo: {
        type: Object,
        default: () => {},
      },
      thumbnailInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        cellList: [],
        bandInfo: null,
        swiperOptions: {
          autoplay: 3500,
          speed: 700,
          autoplayDisableOnInteraction: false,
          pagination: '.swiper-pagination-big-banner',
          paginationType: 'fraction',
          paginationClickable: false,
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          nextButton: '.swiper-button-prev',
          prevButton: '.swiper-button-next',
          parallax: true,
          a11y: true,
          onClick: this.onClickProcessor,
          paginationBulletMessage: '{{index}}번째 배너',
          preloadImages: false,
          lazyLoading: true,
          lazyLoadingInPrevNext: true,
        },
      }
    },
    computed: {
      hasCellList() {
        return this.cellList.length > 0
      },
      isSingleCarousel() {
        return this.cellList.length === 1
      },
    },
    created() {
      this.setData()
    },
    beforeDestroy() {
      this.swiper && this.swiper.destroy && this.swiper.destroy()
    },
    methods: {
      onClickProcessor(swiper) {
        const clickedSlide = swiper?.clickedSlide ?? null
        if (clickedSlide === null) return
        const idx = clickedSlide.getAttribute('data-swiper-slide-index') ?? 0
        if (idx !== '') {
          const { onClick, onNavigation } = fp.flow(
            fp.get('event_list'),
            getCellEventObject,
          )(this.cellList[idx])
          this.$events.$emit(ON_CLICK_CELL, onClick)
          const url = onNavigation?.url ?? ''
          if (url !== '') bannerLink(url)
        }
      },
      async setData() {
        this.bandInfo = await convertBand(this.catalogInfo)
        this.cellList = this.bandInfo?.band?.celllist ?? []

        if (this.isSingleCarousel) {
          this.swiperOptions.loop = false
        }

        this.initSwiperFromEl(this.$refs.multiBanner)
      },
      getAltText(cell) {
        const [title] = cell?.title_list ?? []
        return title?.text ?? ''
      },
    },
  }
</script>
<style lang="scss">
  .picture-area {
    cursor: pointer;
  }
</style>
